import classnames from 'classnames/bind'
import { ComponentType } from 'react'

// Libs
import { LineShopEventId, useLineShopPageView } from '@/methods/lineshop'

// Components
import AuctionLive from './AuctionLive'
import LiveShopping from './LiveShopping'
import HotBrands from './HotBrands'
import HotProducts from './HotProducts'
import ForYouProducts from './ForYouProducts'
import RecentlyViewedProducts from './RecentlyViewedProducts'
import FeaturedCategoryList from '@/components/pages/Home/FeaturedCategoryList'
import HomeMiddleBanner from './MiddleBanner'
import HomeBannerCarousel from './BannerCarousel'
import CategoryPreferenceDialog from '@/components/shared/CategoryPreference/Dialog'

// Constants
import { HOME_SECTION_KEYS, HomeSectionKey } from '@/constants/homeSection'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const SECTION_COMPONENTS: Record<HomeSectionKey, ComponentType> = {
  banner_carousel: HomeBannerCarousel,
  featured_category: FeaturedCategoryList,
  auction_live: AuctionLive,
  live_shopping: LiveShopping,
  middle_banner: HomeMiddleBanner,
  hot_brands: HotBrands,
  for_you: ForYouProducts,
  recently_viewed: RecentlyViewedProducts,
  hot_products: HotProducts,
}

/** 設計稿 Banner 跟優惠專區貼在一起：兩者在後台排序上相鄰時包成一組，中間只剩優惠專區自己的 10px */
const groupSections = (sections: HomeSectionKey[]) =>
  sections.reduce<HomeSectionKey[][]>((groups, key) => {
    const last = groups[groups.length - 1]
    if (key === 'featured_category' && last?.length === 1 && last[0] === 'banner_carousel') last.push(key)
    else groups.push([key])
    return groups
  }, [])

interface IHomeProps {
  // 後台「首頁區塊排序」設定的顯示順序，沒給就用預設順序
  sections?: HomeSectionKey[]
}

const Home = ({ sections = [...HOME_SECTION_KEYS] }: IHomeProps) => {
  useLineShopPageView({ eventId: LineShopEventId.BROWSE_PAGE })

  return (
    <div className={cx('home')}>
      {groupSections(sections).map((group) => {
        if (group.length === 1) {
          const Section = SECTION_COMPONENTS[group[0]]
          return <Section key={group[0]} />
        }

        return (
          <div key={group.join('+')} className={cx('home__top')}>
            {group.map((key) => {
              const Section = SECTION_COMPONENTS[key]
              return <Section key={key} />
            })}
          </div>
        )
      })}
      <CategoryPreferenceDialog />
    </div>
  )
}

export default Home
